module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(['/'].includes(_vm.$route.path)) ? _c('section', {
    staticClass: "hero is-medium"
  }, [_c('div', {
    staticClass: "hero-bg"
  }, [_c('div', {
    staticClass: "hero-head"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('progressbar-logo-refresh')], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_vm._m(1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "button is-black is-large",
    attrs: {
      "to": "/rent-meeting-room-cowork-bratislava"
    }
  }, [_vm._v("\n                    🤝 Meeting Room\n                  ")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "button is-black is-large",
    attrs: {
      "to": "/video"
    }
  }, [_vm._v("🎥 Recordings\n                  ")])], 1)])])])])])])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "section section-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n                🌿 Your favourite coworking, 🍦 community space in\n                "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/gtmznEkBVGG2",
      "title": "location of progressbar"
    }
  }, [_vm._v("\n                downtown, Bratislava")]), _vm._v(" 🪐")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "button is-black is-large",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork!",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("👩‍🔬 Join Coworking")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c6037f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBody.vue
// module id = 91
// module chunks = 24